import RefDataCrudPage from './RefDataCrudPage'
import { driverLicensesApi } from '../api/lookupApi'

export default function LicenseTypesPage() {
  return <RefDataCrudPage api={driverLicensesApi} i18nPrefix="optionDefs.licenseTypes" />
}
